var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Expose } from 'class-transformer';
/**
 * One row of the appointment completion nudge (PRD #804) — a treatment course
 * whose final unit was just confirmed by the appointment confirmation, leaving
 * unbilled delivered units. Returned only for plans that have something to
 * surface: not complete and complete-but-fully-billed are omitted entirely.
 *
 * `billable: true` → the peek renders a "Rechnung erstellen" CTA that opens
 * the existing per-plan `CreatePatientInvoiceModal` with
 * `{ treatmentPlanId, patientId }` — identical to the
 * `unbilled_units_remaining` task-card action. `billable: false` → informational
 * row with `skipReason` (e.g. "Preisvereinbarung fehlt"), no CTA, per the
 * spine's never-hide stance.
 */
export class CompletionNudgeRowDto {
    planId;
    patientId;
    patientName;
    courseComplete;
    eligibleUnitCount;
    billable;
    skipReason;
}
__decorate([
    Expose(),
    __metadata("design:type", String)
], CompletionNudgeRowDto.prototype, "planId", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], CompletionNudgeRowDto.prototype, "patientId", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], CompletionNudgeRowDto.prototype, "patientName", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Boolean)
], CompletionNudgeRowDto.prototype, "courseComplete", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Number)
], CompletionNudgeRowDto.prototype, "eligibleUnitCount", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Boolean)
], CompletionNudgeRowDto.prototype, "billable", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], CompletionNudgeRowDto.prototype, "skipReason", void 0);
//# sourceMappingURL=completion-nudge.response.dto.js.map